export default __webpack_public_path__ + "static/media/rr-logo.69affe18.png";